import { patch, post, remove } from '@/api/base'

const vehicleChambersApi = {
  create: async (vehicleUuid, newChamber) => {
    return await post({
      path: `vehicles/${vehicleUuid}/chambers`,
      params: { ...newChamber },
    })
  },
  update: async (vehicleUuid, chamber) => {
    return await patch({
      path: `vehicles/${vehicleUuid}/chambers/${chamber.uuid}`,
      params: { ...chamber },
    })
  },
  delete: async (vehicleUuid, chamberUuid) => {
    return await remove({
      path: `vehicles/${vehicleUuid}/chambers/${chamberUuid}`,
    })
  },
}

export default vehicleChambersApi
